import React from "react";

const MAX_LABEL_LEN = 90;
const truncate = (s, n = MAX_LABEL_LEN) =>
    typeof s === "string" && s.length > n ? s.slice(0, n - 1) + "…" : s;

const QuestionBar = ({ s, index }) => {
    const totalEvaluated = s.correct + s.wrong;
    const totalForBar = totalEvaluated > 0 ? totalEvaluated : s.answered;
    const isEvaluated = totalEvaluated > 0;

    const pctCorrect =
        isEvaluated && totalForBar
            ? Math.round((s.correct / totalForBar) * 100)
            : 0;
    const pctWrong =
        isEvaluated && totalForBar ? 100 - pctCorrect : 0;

    const W = 420,
        H = 18,
        pad = 1;
    const wCorrect = isEvaluated
        ? Math.round((s.correct / (totalForBar || 1)) * W)
        : 0;
    const wWrong = isEvaluated ? W - wCorrect : 0;

    return (
        <div className="qitem" key={s.questionId}>
            <div className="qlabel" title={s.question}>
                <span className="qindex">{index + 1}.</span>&nbsp;
                {truncate(s.question?.replaceAll?.("%s", "____") || "")}
            </div>

            <div className="qchart">
                {isEvaluated ? (
                    <>
                        <svg
                            width={W}
                            height={H}
                            className="hbar"
                            role="img"
                            aria-label={`Správně ${s.correct}, špatně ${s.wrong}`}
                        >
                            {wCorrect > 0 && (
                                <rect
                                    x="0"
                                    y="0"
                                    width={wCorrect - (wWrong ? pad : 0)}
                                    height={H}
                                    className="seg-correct"
                                    rx="9"
                                    ry="9"
                                />
                            )}
                            {wWrong > 0 && (
                                <rect
                                    x={wCorrect}
                                    y="0"
                                    width={wWrong}
                                    height={H}
                                    className="seg-wrong"
                                    rx="9"
                                    ry="9"
                                />
                            )}
                        </svg>
                        <div className="legend">
              <span className="lg green">
                Správně: {s.correct} ({pctCorrect}%)
              </span>
                            <span className="lg red">
                Špatně: {s.wrong} ({pctWrong}%)
              </span>
                            <span className="lg mut">Celkem vyhodnoceno: {totalForBar}</span>
                        </div>
                    </>
                ) : (
                    <>
                        <svg
                            width={W}
                            height={H}
                            className="hbar neutral"
                            role="img"
                            aria-label={`Zodpovězeno ${s.answered}`}
                        >
                            <rect
                                x="0"
                                y="0"
                                width={W}
                                height={H}
                                className="seg-answered"
                                rx="9"
                                ry="9"
                            />
                        </svg>
                        <div className="legend">
                            <span className="lg blue">Zodpovězeno: {s.answered}</span>
                            <span className="lg mut">(bez vyhodnocení)</span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default QuestionBar;